// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ForkOutlinedSvg from "@fishx/icons-svg/es/asn/ForkOutlined";
import FishxIcon from '../components/FishxIcon';

var ForkOutlined = function ForkOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ForkOutlinedSvg
  }));
};

ForkOutlined.displayName = 'ForkOutlined';
export default React.forwardRef(ForkOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ForkOutlined.js
// module id = 2822
// module chunks = 0